import { message, Modal, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import api from '@/services/api';

const CategoryUpdate = ({ show, onCancel, onUpdate, id, parentId = 0 }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [loadingFetch, setLoadingFetch] = useState(false);
  const [loadingLanguages, setLoadingLanguages] = useState(false);
  const [saving, setSaving] = useState(false);
  const [languagesData, setLanguagesData] = useState([]);

  // 1. Dil verilerini çek
  const fetchLanguages = () => {
    return new Promise((resolve, reject) => {
      setLoadingLanguages(true);
      api()({
        url: '/webshop/management/languages',
        method: 'GET',
      }).then((res) => {
        const activeLangs = res?.data?.filter((x) => x.Active) || [];
        setLanguagesData(activeLangs);
        resolve();
      }).catch(() => {
        message.error('Diller alınamadı');
        reject();
      }).finally(() => {
        setLoadingLanguages(false);
      });
    });
  };

  // 2. Kategori verisini çek (findOne)
  const fetchCategory = async () => {
    setLoadingFetch(true);
    try {
      const res = await api()({
        url: `/webshop/management/tecdoc-menu-install/${id}`,
        method: 'GET',
      });

      const categoryData = res?.data?.data;
      form.setFieldsValue({
        categoryName: categoryData?.name || {},
      });
    } catch (err) {
      message.error('Kategori getirilemedi');
    } finally {
      setLoadingFetch(false);
    }
  };

  // 3. Form gönderimi -> güncelleme (PUT)
  const onFinish = () => {
    form.validateFields().then(async (values) => {
      const categoryName = values.categoryName;

      setSaving(true);
      try {
        const res = await api()({
          url: `/webshop/management/tecdoc-menu-install/${id}`,
          method: 'PUT',
          data: {
            parentId,
            category: categoryName,
          },
        });

        message.success(t('update-success'));
        onUpdate && onUpdate(res?.data?.data); // callback veriyi döner
      } catch (err) {
        message.error(err?.response?.data?.message || t('update-failed'));
      } finally {
        setSaving(false);
      }
    });
  };

  // İlk açıldığında önce dilleri, sonra kategoriyi çek
  useEffect(() => {
    if (!show || !id) return;

    // önce diller, sonra kategori
    fetchLanguages().then(() => {
      fetchCategory();
    });
  }, [show, id]);

  return (
    <Modal
      title={t('update')}
      open={show}
      onCancel={onCancel}
      onOk={onFinish}
      okButtonProps={{ loading: saving }}
      okText={t('save')}
    >
      <Skeleton loading={loadingFetch || loadingLanguages}>
        <Form
          form={form}
          layout="vertical"
          name="category-update-form"
          autoComplete="off"
        >
          {languagesData.map((lang) => (
            <Form.Item
              key={lang.Code}
              label={`${t('category-name')} (${lang.Name})`}
              name={['categoryName', lang.Code]}
              rules={[{ required: true, message: t('field-required') }]}
            >
              <Input placeholder={`${t('category-name')} (${lang.Name})`} />
            </Form.Item>
          ))}
        </Form>
      </Skeleton>
    </Modal>
  );
};

export default CategoryUpdate;
